import styled from '@emotion/styled';

const SubHeaderContainer = styled.div<{ showHeader: boolean }>`
  display: flex;
  gap: 4px;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  transform: ${({ showHeader }) =>
    showHeader ? 'translateY(110px)' : 'translateY(40px)'};
  transition: transform 0.3s ease-in-out;
  overflow-x: auto;
  z-index: 2;
  background-color: var(--dk-bg-subtle, rgb(249, 250, 251));
  padding: 8px 20px 8px 20px;
`;

export { SubHeaderContainer };
